import { selectUndoable } from "../../../../helpers/selector.helpers"
import { AppThunkT } from "../../../store"
import {
    addSelectedAnimationsAction,
    clearSelectedAnimationsAction,
    removeSelectedAnimationsAction,
} from "../../activeAnimation.slice"
import {
    addObjectToSelectedObjectsAction,
    addObjectToSelectedObjectsWithCleanupAction,
    clearAllSelectedObjectsAction,
    selectIsObjectInSelection,
} from "../../activeObject.slice"
import { selectAnimationById } from "./selectAnimationById"

/**
 * Selecting an animation in the timeline, moved out of `useMultiselectAnimation`.
 *
 * The hook is instantiated once per rendered tween and returned nothing but this handler,
 * yet it subscribed to the selection and ran both wrapper hooks (which measure the DOM) on
 * every render. Everything is read from `getState()` here instead.
 */
export const multiselectAnimationAction =
    (animationId: string, ctrlShiftKey: boolean): AppThunkT =>
    (dispatch, getState) => {
        const state = getState()
        const objects = selectUndoable(state).objects
        const animation = selectAnimationById(Object.values(objects.value), animationId)
        if (!animation) return

        if (!ctrlShiftKey) {
            dispatch(clearSelectedAnimationsAction())
            dispatch(clearAllSelectedObjectsAction())
            // setActiveAnimations
            dispatch(addSelectedAnimationsAction([animationId]))
            dispatch(addObjectToSelectedObjectsAction({ id: animation.objectId }))
            return
        }

        if (!state.activeAnimation.selected.includes(animationId)) {
            // do not add the object again when it is already selected or covered by a
            // selected ancestor (this is what the two wrapper hooks used to answer)
            if (!selectIsObjectInSelection(state, animation.objectId)) {
                dispatch(addObjectToSelectedObjectsWithCleanupAction(animation.objectId))
            }
            dispatch(addSelectedAnimationsAction([animationId]))
            return
        }

        dispatch(removeSelectedAnimationsAction([animationId]))
    }
